import styled, { css } from 'react-emotion';
import { Button as UnstyledButton } from '@material-ui/core';
import theme from '@ublend-npm/aulaui-next-web/themes/default';

export const Button = styled(UnstyledButton)`
  height: ${({ compact }) => (compact ? '48px' : '40px')};
  width: ${({ compact }) => (compact ? '344px' : '492px')};
  background: #f6f6f6;
  border-radius: 4px;

  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  text-transform: none;
  display: flex;
  justify-content: space-between;
  box-shadow: none;
  margin-right: 8px;

  padding: 0 8px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export const SpaceContainer = styled('span')`
  display: flex;
  align-items: center;
`;

export const iconClass = css`
  height: 24px;
  width: 24px;
`;

export const Title = styled('span')`
  margin-left: 12px;
  font-family: ${theme.font.family.workSans};
`;
